module.exports = __webpack_public_path__ + "img/users-icon-dark.f30cd8fb.svg";